(function () {
    'use strict';

    angular
        .module('app')
        .controller('FuelController', FuelController);

    FuelController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$location',
        '$timeout',
        '$filter',
        '$translate',
        'blockUI',
        'd3Service',
        '$uibModal',
        'FuelService',
        'SelectService',
        'POSService',
        'TerminalService',
        'NotifyService',
        'uiGmapGoogleMapApi',
        'LANGS'
    ];

    function FuelController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        $timeout,
        $filter,
        $translate,
        blockUI,
        d3Service,
        $uibModal,
        FuelService,
        SelectService,
        POSService,
        TerminalService,
        NotifyService,
        GoogleMapApi,
        LANGS
    ) {
        $scope.isPageMode = isPageMode;
        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.filterHelper = {};

        $scope.multilang = MultilanguageHelper();
        $scope.initLocaleStrings = initLocaleStrings;

        $scope.getFiltersList = SelectService.getLPRList;

        $scope.model = {
            controller: undefined,
            nozzles: [],
            pumps: [],
        };

        $scope.data = {
            currentTab: 'general',
            // loyaltyId: null,
            loyaltiesList: [],
            showDisabledItems: false,
            isEditAdminUrl: true,
            scope: [],

            posList: [],
            terminalList: [],
            terminalListForAdditional: [],
            controllerList: [],
            currentFuelController: null,
            corruptedFields: [],
            alarm_notification_frequency: [
                {id: 0, title: 'Once'},
                {id: 2, title: '2 hours'},
                {id: 6, title: '6 hours'},
                {id: 12, title: '12 hours'},
                {id: 24, title: '24 hours'},
                {id: 36, title: '36 hours'},
                {id: 48, title: '48 hours'}
            ],
            notify_if_connection_lost_more_then_options: [
                {id: 0, title: 'Do not notify'},
                {id: 5, title: '5 minutes'},
                {id: 10, title: '10 minutes'},
                {id: 20, title: '20 minutes'},
                {id: 30, title: '30 minutes'},
                {id: 45, title: '45 minutes'},
                {id: 60, title: '1 hour'}
            ],
            connection_lost_notification_frequency_options: [
                {id: 0, title: 'Once'},
                {id: 2, title: '2 hours'},
                {id: 6, title: '6 hours'},
                {id: 12, title: '12 hours'},
                {id: 24, title: '24 hours'},
                {id: 36, title: '36 hours'},
                {id: 48, title: '48 hours'}
            ],
            price_control_scheme: [
                {id: 'price-from-system', title: 'controller#scheme-type#price-from-system'},
                {id: 'price-from-controller', title: 'controller#scheme-type#price-from-controller'},
                {id: 'none', title: 'controller#scheme-type#none'},
            ],
            pump_authorize_confirmation: [
                {id: 'selected-nozzle-up', title: 'fuelController#selected nozzle up'},
                {id: 'without-nozzle-confirmation', title: 'fuelController#without nozzle confirmation'},
            ]
        };

        $scope.pumpsEditIsReady = false;

        $scope.terminalModel = {
            id: ''
        };

        var fuelControllerModel = {
            active: 1,
            communication_settings: {
                url: '',
                user: '',
                password: ''
            },
            configuration: {},
            configuration_updated: '',
            grades: [],
            id: '',
            nozzles: [],
            pos_id: '',
            terminal_id: '',
            pumps: [],
            title: '',
            type: 'pts-2',
            skip_pumps_in_selection: 0,
            read_gps_data: 0,
            read_probe_measurements: 0,
            notify_if_connection_lost_more_then: 0,
            connection_lost_notification_frequency: 0,
        };


        var block_controllers_list = blockUI.instances.get('controllers_list'),
            block_controller_edit = blockUI.instances.get('controller_edit'),
            block_tab_tanks = blockUI.instances.get('tab-tanks'),
            block_tab_general = blockUI.instances.get('tab-general'),
            block_tab_pumps = blockUI.instances.get('tab-pumps'),
            block_external_access = blockUI.instances.get('block_external_access');

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Page mode display different parts. Now 'show', 'create', 'edit'.
         * Use as <ANY ng-if="isPageMode('show')">
         */

        function isPageMode(mode) {
            return mode === $scope._pageMode;
        }

        /**
         * Check parameter 'mode' in route ../client-accounts/{mode}
         */
        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        /**
         * Initialize page mode by url
         */
        function initPageMode() {
            $scope._pageMode = 'show';
            if (isRouteMode('edit')) {
                if ($routeParams['tab'] && $routeParams['tab'] !== 'general') {
                    $scope.data.currentTab = $routeParams['tab'];
                }
                $scope._pageMode = ($routeParams.hasOwnProperty('loyalty_id') && $routeParams.hasOwnProperty('controller_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }
        }

        /**
         * Initialize controller
         */
        function initControllerPage() {
            $scope.multilang.initLangs(LANGS, $rootScope.LANG);
            var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
                loadFuelControllerScope();
            });
            $scope.$on('$destroy', unbindTranslateChangeSuccess);
            loadFuelControllerScope();
            initPageMode();

            switch ($scope._pageMode) {
                case 'create':
                    //doCreate();
                    break;

                case 'show':
                    // вызываем после получения списка лояльностей
                    // _doShow();
                    break;

                case 'edit':
                    _doEdit();
                    break;
            }
        }


        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************
        /**
         * Prepare data for display page in mode 'show'
         */
        function _doShow() {
            loadControllers();
        }

        function loadControllers() {

            block_controllers_list.start();
            var params = {};

            FuelService.getControllerList($scope.filterHelper.id, params, function (success, data) {
                if (success) {

                    $scope.controllersList = data.map(function (item) {
                        item.allAlarms = [];
                        if (item.tanks) {
                            item.tanks.forEach(function (tank) {
                                if (tank.actual_measurements && tank.actual_measurements.alarms) {
                                    item.allAlarms = item.allAlarms.concat(tank.actual_measurements.alarms);
                                }
                            });
                        }
                        return item;
                    });
                }
                block_controllers_list.stop();
            });
        }

        function loadFuelControllerScope() {
            FuelService.getControllerExternalAccessScope(function (success, data) {
                if (success) {
                    $scope.data.scope = data;
                }
            })
        }

        $scope.onSelectFilter = function (id, item) {
            loadControllers();
        };

        $scope.onChangeShowOnlyActive = function () {
            loadControllers();
        };


        function setLoyaltyId() {
            if ($rootScope.ENV.filters && $rootScope.ENV.filters.categories_list && $rootScope.ENV.filters.categories_list.loyalty_id) {
                $scope.data.loyaltyId = $rootScope.ENV.filters.categories_list.loyalty_id;
            }

            if (!$scope.data.loyaltyId && $scope.data.loyaltiesList && $scope.data.loyaltiesList.length > 0) {
                $scope.data.loyaltyId = getFirstActive($scope.data.loyaltiesList).id;
            }
        }

        function getControllerList() {
            var loyaltyId;

            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id) {
                loyaltyId = $scope.data.currentLoyalty.id;
            } else {
                setLoyaltyId();
                loyaltyId = $scope.data.loyaltyId;
            }

            FuelService.getControllerList(loyaltyId, [], function (success, response) {
                if (success) {
                    $scope.controllersList = response;
                }
            });
        }

        /**
         * Validate recommended values form
         */
        function validateFuelController(formData) {

            var validationResult = {
                isValid: true,
                corruptedFields: []
            };

            for (var validatorName in $scope.fuelControllerValidator) {
                var isValid = $scope.fuelControllerValidator[validatorName](formData);
                if (!isValid) {
                    validationResult.corruptedFields.push(validatorName);
                    validationResult.isValid = false;
                }
            }

            return validationResult;
        }

        /**
         * Save to server fuel controller value
         */
        function saveFuelController(fuelController, saveCallback) {
            var loyaltyId;
            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id) {
                loyaltyId = $scope.data.currentLoyalty.id;
            } else {
                setLoyaltyId();
                loyaltyId = $scope.data.loyaltyId;
            }

            var controllerData = fuelController;

            controllerData.configuration_updated = dtFormat(new Date());

            if (controllerData.id) {
                var controllerId = controllerData.id;
                FuelService.updateFuelController(loyaltyId, controllerId, controllerData, saveCallback);
            } else {
                FuelService.addFuelController(loyaltyId, controllerData, saveCallback);
            }
        }

        $scope.saveFuelController = function (form, switchToControllerList) {
            var validationResult = validateFuelController();

            $scope.data.corruptedFields = validationResult.corruptedFields;

            if (validationResult.isValid) {

                block_tab_general.start();

                var callback = function (success, data) {

                    if (success) {
                        if (!!switchToControllerList) {
                            $scope.model.controller = null;
                            $location.path('/fuel-controllers');
                        } else {
                            $scope.model.controller = data;
                        }
                        form.$setPristine();
                        NotifyService.Success('', false);
                    }
                    block_tab_general.stop();
                };

                saveFuelController($scope.model.controller, callback);
            }
        };

        $scope.onChangeTab = function (tab) {
            console.info('TAB', tab);
            switch ($scope.data.currentTab) {
                case 'general':

                    var generalForm = angular.element('#fuel-controllers-general').scope().form;

                    if (generalForm.$dirty) {
                        $uibModal.open({
                            animation: true,
                            keyboard: true,
                            size: 'sm',
                            templateUrl: 'app/templates/modal.confirmation.html',
                            controllerAs: 'popup',
                            controller: function ($uibModalInstance) {
                                var popup = this;

                                popup.type = 'fuel-controllers';

                                popup.onSaveClick = function (exit) {

                                    generalForm.$setPristine();
                                    $scope.saveFuelController(generalForm);

                                    $scope.onChangeTab(tab)

                                    $uibModalInstance.close();
                                };

                                popup.onCancelClick = function (exit) {
                                    $uibModalInstance.close();
                                };
                            }
                        });
                        return;
                    }
                    break;
                case 'pumps':
                    if (nozzleGradeToChange.length || nozzleTankToChange.length || pumpMainTerminalToChange.length || pumpAdditionalTerminalsToChange.length) {
                        $uibModal.open({
                            animation: true,
                            keyboard: true,
                            size: 'sm',
                            templateUrl: 'app/templates/modal.confirmation.html',
                            controllerAs: 'popup',
                            controller: function ($uibModalInstance) {
                                var popup = this;

                                popup.type = 'fuel-controllers';

                                popup.onSaveClick = function (exit) {

                                    $scope.saveNozzles();

                                    $scope.onChangeTab(tab);

                                    $uibModalInstance.close();
                                };

                                popup.onCancelClick = function (exit) {
                                    $uibModalInstance.close();
                                };
                            }
                        });
                        return;
                    }
                    break;
            }

            switch (tab) {
                case 'pumps':
                    block_tab_pumps.start();
                    if ($scope.data.currentTab !== 'pumps' && $scope.model.controller.pumps && $scope.model.controller.pumps.length > 0 && !!$scope.model.controller.pos) {
                        $scope.pumpsEditIsReady = false;
                    }

                    loadAllPumpTerminals()
                        .then(function () {
                        })
                        .catch(function (err) {
                        })
                        .finally(function () {
                            block_tab_pumps.stop();
                        });

                    break;
                case 'external-access':
                    loadExternalAccessInfo();
                    break;
            }

            $scope.data.currentTab = tab;
            $location.url($location.$$path + '?tab=' + tab);
        };

        function loadExternalAccessInfo() {
            var loyaltyId = $routeParams.loyalty_id;
            var controllerId = $scope.model.controller.id;
            FuelService.getControllerExternalAccessList(loyaltyId, controllerId, function (success, data) {
                if (success) {
                    $scope.model.controller.external_access = data;
                }
                block_external_access.stop();
            });
        }

        // Pump data form validation
        $scope.fuelControllerValidator = {
            isTitleValid: function (formData) {
                var form = formData || $scope.model.controller;
                return !!form && form.title.length;
            },
            isPosValid: function (formData) {
                var form = formData || $scope.model.controller;
                return !!form && ((!!$scope.model.controller && !!form.pos_id) || !$scope.model.controller);
                // return !!form && !!form.pos_id;
            },
            isUrlValid: function (formData) {
                var form = formData || $scope.model.controller;
                return !!form && form.communication_settings.url.length;
            },
            isUsernameValid: function (formData) {
                var form = formData || $scope.model.controller;
                return !!form && form.communication_settings.user.length;
            },
            isPasswordValid: function (formData) {
                var form = formData || $scope.model.controller;
                return !!form && form.communication_settings.password.length;
            }
        };

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                if ($rootScope.ENV.filters && $rootScope.ENV.filters.categories_list && $rootScope.ENV.filters.categories_list.loyalty_id) {
                    var loyalty_id = $rootScope.ENV.filters.categories_list.loyalty_id;
                    var hasLoyalty = $scope.data.loyaltiesList.find(function (loyalty) {
                        return loyalty.id === loyalty_id;
                    });
                    if (hasLoyalty) {
                        $scope.filterHelper.id = $rootScope.ENV.filters.categories_list.loyalty_id;
                    }

                }

                if (!$scope.filterHelper.id) {
                    console.log('if (!$scope.filterHelper.id) {')
                    $scope.filterHelper.id = getFirstActive($scope.data.loyaltiesList).id;
                }
                if ($scope._pageMode === 'show') {
                    _doShow();
                }
            }
        });

        //
        $scope.$watch('filterHelper.id', function (newValue, oldValue, scope) {
            if (newValue && newValue !== oldValue) {
                if ($scope._pageMode === 'show') {
                    _doShow();
                    $rootScope.ENV.filters.categories_list = {
                        loyalty_id: newValue
                    };
                    $rootScope.storeENV();
                }
            }
        });

        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;

        $scope.openModalFuelController = function (controllerItem) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/fuel-controllers/fuel_controllers.add.modal.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.fuelController = !!controllerItem ? controllerItem : fuelControllerModel;

                    popup.fuelController.pump_authorize_type = 'amount';

                    var saveCallback = function (success, response) {
                        if (success) {
                            NotifyService.Success('', false);
                            getControllerList();
                            $uibModalInstance.close();
                        }
                    };

                    popup.saveFuelController = function () {
                        var validationResult = validateFuelController(popup.fuelController);

                        popup.corruptedFields = validationResult.corruptedFields;
                        if (validationResult.isValid) {
                            saveFuelController(popup.fuelController, saveCallback);
                        }
                    };

                    popup.closeModal = function () {
                        $uibModalInstance.close();
                    }
                }
            });
        };

        function setCurrentController(controllerId) {
            $location.path('/fuel-controllers/' + controllerId);
            var loyaltyId = $scope.data.loyaltyId;
            FuelService.getControllerItem(loyaltyId, controllerId, function (success, data) {
                if (success) {
                    $scope.data.currentFuelController = data;
                }
            });
        }

        $scope.selectFuelController = function (controllerId) {
            setCurrentController(controllerId);
        };

        /**
         * закрыть редактирование
         */
        $scope.onCancelEdit = function () {
            $location.path('/fuel-controllers');
        };

        function toggleTerminal(pump, loyaltyId, controllerId) {
            return new Promise((resolve) => {
                var callback = function (success, data) {
                    if (success) {
                        resolve(data);
                        $scope.data.currentFuelController = data;
                    } else {
                        resolve();
                    }
                };

                if (pump.terminal_id.length) {
                    var controllerData = {id: pump.terminal_id};
                    FuelService.setPumpTerminal(loyaltyId, controllerId, pump.id, controllerData, callback);

                } else {
                    FuelService.deletePumpTerminal(loyaltyId, controllerId, pump.id, callback);
                }
            })
        }

        function toggleTerminals(pump, loyaltyId, controllerId) {
            return new Promise((resolve) => {
                var callback = function (success, data) {
                    if (success) {
                        resolve(data);
                        $scope.data.currentFuelController = data;
                    } else {
                        resolve();
                    }
                };
                var terminalsData = pump.terminals;
                FuelService.updatePumpTerminals(loyaltyId, controllerId, pump.id, terminalsData, callback);
            })
        }

        $scope.toggleFuelControllerStatus = function (fuelController, status) {
            var loyaltyId;
            if ($scope.data.currentLoyalty && $scope.data.currentLoyalty.id) {
                loyaltyId = $scope.data.currentLoyalty.id;
            } else {
                setLoyaltyId();
                loyaltyId = $scope.data.loyaltyId;
            }

            FuelService.getControllerItem(loyaltyId, fuelController.id, function (success, data) {
                if (success) {
                    data.active = !!status ? 1 : 0;
                    FuelService.updateFuelController(loyaltyId, data.id, data, function (success, data) {
                        fuelController.active = data.active;
                        if (success) {
                            NotifyService.Success('', false);
                        }
                    });
                }
            });
        };

        $scope.getPumpTerminalOptions = function ($select) {
            if ($scope.pumpsEditIsReady === false) {
                $scope.pumpsEditIsReady = $scope.model.controller.pumps.length;
            }


            var withoutValue = {
                id: '',
                title: $translate.instant('Without Terminal')
            };

            var exists = $select.items.find(function (item) {
                return item && item.id === withoutValue.id;
            });

            if (!exists) {
                $select.items = [withoutValue].concat($select.items);
                if (!$select.selected) $select.selected = withoutValue;
            }

            if ($scope.pumpsEditIsReady <= 1) {
                $scope.pumpsEditIsReady = true;
                block_controller_edit.stop()
            } else {
                $scope.pumpsEditIsReady--;
            }
        };


        // *********************************************************************************************
        //  CREATE & EDIT PART
        // *********************************************************************************************
        /**
         * Init loyalty string
         */
        function initLocaleStrings(goods_category) {
            $scope.multilang.initStrings(goods_category, ['public_title']);
        }

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage = function (new_lang) {
            $scope.multilang.selected(new_lang);
        };

        function loadAllPumpTerminals() {
            return new Promise(function (resolve, reject) {
                var pumps = $scope.model.pumps;

                if (!Array.isArray(pumps) || pumps.length === 0) {
                    return resolve();
                }

                function getPumpTerminals(index) {
                    return new Promise(function (resolvePump, rejectPump) {
                        FuelService.getPumpTerminals(
                            $routeParams.loyalty_id,
                            $routeParams.controller_id,
                            pumps[index].id,
                            function (success, data) {
                                if (success) {
                                    pumps[index].terminals = data;
                                    resolvePump();
                                } else {
                                    rejectPump(new Error('Get pump terminals error: ' + index));
                                }
                            }
                        );
                    });
                }

                function load(index) {
                    if (index >= pumps.length) {
                        return resolve();
                    }

                    getPumpTerminals(index)
                        .then(function () {
                            load(index + 1);
                        })
                        .catch(function (err) {
                            reject(err);
                        });
                }

                load(0);
            });
        }


        /**
         *
         * @private
         */
        function _doEdit() {
            block_controller_edit.start();

            POSService.forLoyalty($routeParams.loyalty_id, function (success, data) {
                if (success) {
                    $scope.data.posList = data;
                    FuelService.getControllerItem($routeParams.loyalty_id, $routeParams.controller_id, function (success, data) {
                        if (success) {
                            $scope.model.controller = angular.copy(data);
                            if ($scope.model.controller.communication_settings.admin_interface_url) {
                                $scope.data.isEditAdminUrl = false;
                            }
                            $scope.model.nozzles = angular.copy(data.nozzles);
                            $scope.model.pumps = angular.copy(data.pumps);

                            TerminalService.All(function (success, data) {
                                if (success) {
                                    $scope.data.terminalList = data.filter(function (item) {
                                        return item && item.pos_id === $scope.model.controller.pos_id;
                                    });

                                    $scope.data.terminalListForAdditional = [];
                                    $scope.data.terminalList.forEach(function (item) {
                                        var newItem = {
                                            active: item.active,
                                            currency: item.currency,
                                            id: item.id,
                                            title: item.title,
                                            type: item.type,
                                        }
                                        $scope.data.terminalListForAdditional.push(newItem);
                                    });
                                }
                                block_controller_edit.stop();
                            });

                            $scope.data.currentLoyalty = itemByIndex($scope.data.loyaltiesList, $scope.model.controller.loyalty_id);

                            if ($scope.model.pumps.length === 0) {
                                block_controller_edit.stop();
                            }

                        } else {
                            block_controller_edit.stop();
                            $location.path('/fuel-controllers');
                        }
                    });
                }
            });
        }

        // $rootScope.$watch('POS', function (newValue, oldValue) {
        //     if (newValue && newValue.length > 0) {
        //         $scope.data.posList = angular.copy($rootScope.POS);
        //     }
        // });
        $scope.refreshTanks = function () {
            block_tab_tanks.start();
            FuelService.getControllerItem($routeParams.loyalty_id, $routeParams.controller_id, function (success, data) {
                if (success) {
                    $scope.model.controller.tanks = angular.copy(data.tanks);
                } else {
                    $location.path('/fuel-controllers');
                }
                block_tab_tanks.stop();
            });

        };
        $scope.onShowAlertTank = function (alarms, event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/fuel-controllers/modals/modal.alerts-tank.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.alerts = alarms;

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            });
        };

        // $scope.getNozzleOptions = function ($select) {
        //     var withoutValue = {
        //         id: '',
        //         code: $translate.instant('Not selected'),
        //         internal_id: $translate.instant('Not selected')
        //     };
        //
        //     var exists = $select.items.find(function (item) {
        //         return item && item.id === withoutValue.id;
        //     });
        //
        //     if (!exists) {
        //         $select.items = [withoutValue].concat($select.items);
        //         if (!$select.selected) $select.selected = withoutValue;
        //     }
        // };

        function editTankGradeCallback(success, data) {
            if (success) {
                NotifyService.Success('', false);
                $scope.model.controller = data;
            }
            block_tab_tanks.stop();
        }

        function selectNozzleGrade(nozzle, loyaltyId, controllerId) {
            return new Promise((resolve) => {
                if (nozzle.grade_id.length) {
                    var gradeData = {
                        id: nozzle.grade_id
                    }
                    FuelService.setGradeForNozzle(loyaltyId, controllerId, nozzle.id, gradeData, (success, data) => {
                        if (success) {
                            resolve(data);
                        } else {
                            resolve();
                        }
                    });
                } else {
                    FuelService.removeGradeForNozzle(loyaltyId, controllerId, nozzle.id, (success, data) => {
                        if (success) {
                            resolve(data);
                        } else {
                            resolve();
                        }
                    });
                }
            })
        }

        function selectNozzleTank(nozzle, loyaltyId, controllerId) {
            return new Promise((resolve) => {
                if (nozzle.tank_id.length) {
                    var gradeData = {
                        id: nozzle.tank_id
                    }
                    FuelService.setTankForNozzle(loyaltyId, controllerId, nozzle.id, gradeData, (success, data) => {
                        if (success) {
                            resolve(data);
                        } else {
                            resolve();
                        }
                    });
                } else {
                    FuelService.removeTankForNozzle(loyaltyId, controllerId, nozzle.id, (success, data) => {
                        if (success) {
                            resolve(data);
                        } else {
                            resolve();
                        }
                    });
                }
            })
        }

        $scope.selectTankGrade = function (tank) {
            var loyaltyId = $scope.model.controller.loyalty_id;
            var controllerId = $scope.model.controller.id;

            block_tab_tanks.start();
            if (tank.grade_id.length) {
                var gradeData = {
                    id: tank.grade_id
                }
                FuelService.setGradeForTank(loyaltyId, controllerId, tank.id, gradeData, editTankGradeCallback);
            } else {
                FuelService.removeGradeForTank(loyaltyId, controllerId, tank.id, editTankGradeCallback);
            }
        };

        var nozzleGradeToChange = [];
        var nozzleTankToChange = [];
        var pumpMainTerminalToChange = [];
        var pumpAdditionalTerminalsToChange = [];

        $scope.saveNozzles = function () {
            const loyaltyId = $scope.model.controller.loyalty_id;
            const controllerId = $scope.model.controller.id;

            block_tab_pumps.start();

            const emptyTerminalsPumps = pumpAdditionalTerminalsToChange.filter(p => !p.terminals || p.terminals.length === 0);
            const nonEmptyTerminalsPumps = pumpAdditionalTerminalsToChange.filter(p => p.terminals && p.terminals.length > 0);
            pumpAdditionalTerminalsToChange = [];

            const runSequential = (items, fn) => {
                return items.reduce((chain, item) => chain.then(() => fn(item, loyaltyId, controllerId)), Promise.resolve());
            };

            runSequential(emptyTerminalsPumps, toggleTerminals)

                .then(() => {
                    const parallel = [];

                    nozzleGradeToChange.forEach(nozzle => {
                        parallel.push(selectNozzleGrade(nozzle, loyaltyId, controllerId));
                    });
                    nozzleGradeToChange = [];

                    nozzleTankToChange.forEach(nozzle => {
                        parallel.push(selectNozzleTank(nozzle, loyaltyId, controllerId));
                    });
                    nozzleTankToChange = [];

                    pumpMainTerminalToChange.forEach(pump => {
                        parallel.push(toggleTerminal(pump, loyaltyId, controllerId));
                    });
                    pumpMainTerminalToChange = [];

                    return Promise.all(parallel);
                })

                .then(results => {
                    if (results[results.length - 1]) {
                        $scope.model.controller = angular.copy(results[results.length - 1]);
                        $scope.model.nozzles = angular.copy($scope.model.controller.nozzles);
                        $scope.model.pumps = angular.copy($scope.model.controller.pumps);
                    }
                })
                .then(() => runSequential(nonEmptyTerminalsPumps, toggleTerminals))

                .then(() => {
                    loadAllPumpTerminals()
                        .then(function () {
                            NotifyService.Success('', false);
                        })
                        .catch(function (err) {
                        })
                        .finally(function () {
                            block_tab_pumps.stop();
                        });
                })
                .catch(error => {
                    NotifyService.Error(error.message, false);
                    $timeout(() => block_tab_pumps.stop(), 200);
                    console.error('error:', error);
                })
        };

        $scope.checkNozzleGrade = function (nozzle, index) {
            var oldNozzleValue = $scope.model.controller.nozzles[index];
            const i = nozzleGradeToChange.findIndex(value => value.id === nozzle.id);

            if (nozzle.grade_id !== oldNozzleValue.grade_id) {
                if (i !== -1) {
                    nozzleGradeToChange[i] = nozzle;
                } else {
                    nozzleGradeToChange.push(nozzle);
                }
            } else {
                if (i !== -1) {
                    nozzleGradeToChange.splice(i, 1);
                }
            }
        };


        $scope.checkNozzleTank = function (nozzle, index) {
            var oldNozzleValue = $scope.model.controller.nozzles[index];
            const i = nozzleTankToChange.findIndex(value => value.id === nozzle.id);

            if (nozzle.tank_id !== oldNozzleValue.tank_id) {
                if (i !== -1) {
                    nozzleTankToChange[i] = nozzle;
                } else {
                    nozzleTankToChange.push(nozzle);
                }
            } else {
                if (i !== -1) {
                    nozzleTankToChange.splice(i, 1);
                }
            }
        };

        $scope.checkPumpTerminal = function (pump, index) {
            const i = pumpMainTerminalToChange.findIndex(value => value.id === pump.id);
            var oldPumpValue = $scope.model.controller.pumps[index];

            if (pump.terminal_id !== oldPumpValue.terminal_id) {
                if (i !== -1) {
                    pumpMainTerminalToChange[i] = pump;
                } else {
                    pumpMainTerminalToChange.push(pump);
                }
                if (!pump.terminal_id) {
                    pump.terminals = [];
                    $scope.checkAdditionalPumpsTerminal(pump, index);
                }
            } else {
                if (i !== -1) {
                    pumpMainTerminalToChange.splice(i, 1);
                }
            }
        };

        $scope.checkAdditionalPumpsTerminal = function (pump, index) {
            const i = pumpAdditionalTerminalsToChange.findIndex(value => value.id === pump.id);
            const oldPumpValue = $scope.model.controller.pumps[index];

            if (pump.terminals !== oldPumpValue.terminals) {
                if (i !== -1) {
                    pumpAdditionalTerminalsToChange[i] = pump;
                } else {
                    pumpAdditionalTerminalsToChange.push(pump);
                }
            } else {
                if (i !== -1) {
                    pumpAdditionalTerminalsToChange.splice(i, 1);
                }
            }
        };


        $scope.tagHandler = function (tag) {
            return null;
        }

        $scope.onShowQR = function (controller) {
            console.log('pos', controller)
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.fuel-controllers.link.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        link: 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] + '/fuel/{0}?auth_token={token}'.format(controller.pos_id)
                    }

                    popup.onPrint = function () {
                        var printContents = document.getElementById('printable-qr').innerHTML,
                            canvas_qr_dataurl = document.getElementsByTagName('canvas')[0].toDataURL(),
                            canvas_string = '<canvas class="qrcode" height="512" width="512"></canvas>',
                            popupWin = window.open('', '_blank', 'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);

                        printContents = printContents.replace(canvas_string, '<img src="' + canvas_qr_dataurl + '">');

                        popupWin.document.open();
                        popupWin.document.write('<html><head><base href="/"><title></title>' +
                            '<link href="assets/print/print_qr.min.css" rel="stylesheet"/></head>' +
                            '<body>' + printContents + '</body></html>');
                        popupWin.focus();
                        // setTimeout(function () {
                        //     popupWin.document.execCommand('print');
                        //     popupWin.print();
                        //     popupWin.document.close();
                        //     popupWin.close();
                        // }, 10);
                        var count = popupWin.document.querySelectorAll('img, link').length;

                        function printOnLoad() {
                            setTimeout(function () {
                                popupWin.focus();
                                popupWin.document.execCommand('print');
                                // popupWin.print();
                                popupWin.document.close();
                                popupWin.close();
                            }, 200);
                        }

                        if (count) {
                            popupWin.document.querySelectorAll('img, link').forEach(function (el) {
                                el.onload = function () {
                                    if (!--count) {
                                        printOnLoad()
                                    }
                                };
                            });
                        } else {
                            printOnLoad()
                        }
                    }

                    popup.onCopyLink = function () {
                        $uibModalInstance.close();
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            });
        }

        $scope.changeEditAdminUrl = function (showInput, form) {
            if (showInput === false) {
                if ($scope.model.controller.communication_settings.admin_interface_url) {
                    $scope.data.isEditAdminUrl = showInput;
                    $scope.saveFuelController(form);
                } else {
                    $scope.saveFuelController(form);
                }
            } else {
                $scope.data.isEditAdminUrl = showInput;
            }
        }

        $scope.addExternalAccess = function () {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/fuel-controllers/modals/modal.external-access.add.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.data = {
                        title: '',
                        scope: []
                    }
                    popup.scope = [];
                    $scope.data.scope.forEach(function (el) {
                        popup.scope.push({
                            title: el.title,
                            value: el.value,
                            checked: false
                        })
                    })
                    popup.onCreateAccess = function () {
                        popup.scope.forEach(function (el) {
                            if (el.checked) {
                                popup.data.scope.push(el.value)
                            }
                        })
                        var loyaltyId = $routeParams.loyalty_id;
                        var controllerId = $scope.model.controller.id;
                        block_external_access.start();
                        FuelService.addControllerExternalAccess(loyaltyId, controllerId, popup.data, function (success, data) {
                            if (success) {
                                NotifyService.Success('', false);
                                loadExternalAccessInfo();
                                $uibModalInstance.close();
                            }
                        })
                    }
                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            })
        }

        $scope.onAccessDeleteClick = function (item) {
            var loyaltyId = $routeParams.loyalty_id;
            var controllerId = $scope.model.controller.id;
            block_external_access.start();
            FuelService.removeControllerExternalAccess(
                loyaltyId,
                controllerId,
                item.id,
                function (success, data) {
                    if (success) {
                        NotifyService.Success('', false);
                        loadExternalAccessInfo();
                    }
                }
            )
        }

        $scope.onAccessEditClick = function (item) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/fuel-controllers/modals/modal.external-access.edit.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.data = {
                        title: item.title,
                        scope: []
                    }
                    popup.scope = [];

                    $scope.data.scope.forEach(function (el) {
                        var checked = item.scope.find(function (scopeItem) {
                            return scopeItem === el.value;
                        })

                        popup.scope.push({
                            title: el.title,
                            value: el.value,
                            checked: !!checked
                        })
                    })

                    popup.onCreateAccess = function () {
                        popup.data.scope = [];
                        popup.scope.forEach(function (el) {
                            if (el.checked) {
                                popup.data.scope.push(el.value)
                            }
                        })
                        var loyaltyId = $routeParams.loyalty_id;
                        var controllerId = $scope.model.controller.id;
                        block_external_access.start();
                        FuelService.updateControllerExternalAccess(loyaltyId, controllerId, item.id, popup.data, function (success, data) {
                            if (success) {
                                NotifyService.Success('', false);
                                loadExternalAccessInfo();
                                $uibModalInstance.close();
                            }
                        })
                    }
                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            })
        }

        $scope.popupAPIKEY = function (api_key) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                templateUrl: 'app/pages/fuel-controllers/modals/modal.show-api-key.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.api_key = api_key;

                    popup.onAPIKEYCopy = function () {
                        popup.APIKEYCopied = true;
                        $timeout(function () {
                            popup.APIKEYCopied = false;
                        }, 3000);
                    };

                    popup.onCancelClick = function (exit) {
                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.openModalInventoryData = function (grade) {
            console.log($scope.model.controller.grades)
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'lg',
                backdrop: 'static',
                templateUrl: 'app/pages/fuel-controllers/modals/modal.inventory-data.edit.html',
                controllerAs: 'popup',
                windowClass: 'full-modal',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    var loyaltyId = $routeParams.loyalty_id;
                    var controllerId = $scope.model.controller.id;
                    var receipt_block = blockUI.instances.get('inventory_data');

                    popup.controller = null;
                    popup._mode = 'view';
                    popup.deliveries = [];
                    popup.storedDeliveries = [];
                    popup.grade = grade;
                    popup.controller = $scope.model.controller;
                    popup.params = {
                        date_from: moment().add(-1, 'year').startOf('day').utc().toDate(),
                        date_to: moment().endOf('day').utc().toDate(),
                        time_from: moment().startOf('day').utc().toDate(),
                        time_to: moment().endOf('day').utc().toDate(),
                    }
                    popup.average_cost_values = $scope.gradeAverageCost(grade);
                    popup.average_cost = null;
                    popup.getDeliveries = function () {
                        var params = angular.copy(popup.params);

                        if (params.date_from && params.time_from) {
                            params.date_from = moment(params.date_from).set({
                                hour: moment(params.time_from).get('hour'),
                                minute: moment(params.time_from).get('minute'),
                                second: moment(params.time_from).get('second')
                            });
                            delete params.time_from;
                        }
                        if (params.date_to && params.time_to) {
                            params.date_to = moment(params.date_to).set({
                                hour: moment(params.time_to).get('hour'),
                                minute: moment(params.time_to).get('minute'),
                                second: moment(params.time_to).get('second')
                            });
                            delete params.time_to;
                        }
                        params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);

                        FuelService.getGradeAverageCostsDeliveries(loyaltyId, controllerId, grade.id, params, function (success, result) {
                            if (success) {
                                result.map(function (el) {
                                    if (el.delivery_datetime) {
                                        el.delivery_date = moment(el.delivery_datetime).utc().toDate()
                                        el.delivery_time = moment(el.delivery_datetime).utc().toDate()
                                    } else {
                                        el.delivery_date = moment().startOf('day').utc().toDate();
                                        el.delivery_time = moment().utc().toDate();
                                    }
                                    el.toDelete = false;
                                    el.toUpdate = false;
                                    return el;
                                })
                                popup.deliveries = result;
                                popup.storedDeliveries = result;

                                if (popup.deliveries.length > 0) {
                                    FuelService.getGradeAverageCostsByDate(loyaltyId, controllerId, grade.id, {date: params.date_to}, function (success, result) {
                                        if (success) {
                                            popup.average_cost = result;
                                            popup.average_cost_values = {
                                                pos_title: popup.controller.pos.title,
                                                inventory_value: popup.average_cost.average_cost,
                                                unit: popup.controller.configuration.measurement_units.volume,
                                                date: moment(popup.average_cost.delivery_datetime).format('DD, MMMM Do YYYY, h:mm:ss a'),
                                            }
                                        }
                                        receipt_block.stop();
                                    })
                                } else {
                                    receipt_block.stop();
                                }

                            } else {
                                receipt_block.stop();
                            }
                        })
                    }

                    receipt_block.start();
                    popup.getDeliveries();

                    popup.applyDateFilter = function () {
                        receipt_block.start();
                        popup.getDeliveries();
                    }

                    popup.addDelivery = function () {
                        var newDelivery = {
                            delivery_cost: 0,
                            delivery_date: moment().startOf('day').utc().toDate(),
                            delivery_time: moment().utc().toDate(),
                            delivery_volume: 0,
                            product_volume_before_delivery: 0,
                            delivery_vehicle_id: '',
                            edit: true,
                            toUpdate: true,
                            toDelete: false,
                        }
                        popup.deliveries.push(newDelivery);
                    }

                    popup.editDelivery = function (delivery) {
                        if (delivery.delivery_datetime) {
                            delivery.delivery_date = moment(delivery.delivery_datetime).utc().toDate()
                            delivery.delivery_time = moment(delivery.delivery_datetime).utc().toDate()
                        } else {
                            delivery.delivery_date = moment().startOf('day').utc().toDate();
                            delivery.delivery_time = moment().utc().toDate();
                        }
                        delivery.edit = true;
                    }

                    popup.deleteDelivery = function (k) {
                        var delivery = popup.deliveries[k];
                        if (!delivery.delivery_id) {
                            popup.deliveries.splice(k, 1)
                            return;
                        }
                        popup.deliveries[k].toDelete = true;
                    }

                    popup.saveDelivery = function (delivery) {
                        if (delivery.delivery_date && delivery.delivery_time) {
                            delivery.delivery_datetime = moment(delivery.delivery_date).set({
                                hour: moment(delivery.delivery_time).get('hour'),
                                minute: moment(delivery.delivery_time).get('minute'),
                                second: moment(delivery.delivery_time).get('second')
                            });
                        }

                        delivery.edit = false;
                        delivery.toUpdate = true;
                    }

                    popup.editData = function () {
                        receipt_block.start();
                        popup._mode = 'edit';
                        receipt_block.stop();
                    }

                    popup.viewData = function () {
                        if (popup.canSave()) {
                            popup.getDeliveries();
                            popup._mode = 'view';
                        } else {
                            receipt_block.start();
                            popup._mode = 'view';
                            receipt_block.stop();
                        }
                    }

                    popup.closeModal = function () {
                        $uibModalInstance.close();
                    }

                    popup.canSave = function () {
                        var updateData = popup.deliveries.filter(function (el) {
                            return el.toUpdate
                        })

                        var deleteData = popup.deliveries.filter(function (el) {
                            return el.toDelete
                        })

                        return updateData.length !== 0 || deleteData.length !== 0;
                    }

                    popup.onSave = function () {
                        console.log(popup.canSave())
                        receipt_block.start();
                        var updateData = popup.deliveries.filter(function (el) {
                            return el.toUpdate
                        })

                        var deleteData = popup.deliveries.filter(function (el) {
                            return el.toDelete
                        })

                        if (updateData.length > 0) {
                            FuelService.editGradeAverageCostsDeliveries(loyaltyId, controllerId, grade.id, updateData, function (successUpdate, resultUpdate) {
                                if (deleteData.length > 0) {
                                    FuelService.deleteGradeAverageCostsDeliveries(loyaltyId, controllerId, grade.id, deleteData, function (success, result) {
                                        if (success) {
                                            popup.getDeliveries()
                                        } else {
                                            receipt_block.stop();
                                        }
                                    })
                                } else {
                                    if (successUpdate) {
                                        popup.getDeliveries()
                                    } else {
                                        receipt_block.stop();
                                    }
                                }
                            })
                        } else {
                            if (deleteData.length > 0) {
                                FuelService.deleteGradeAverageCostsDeliveries(loyaltyId, controllerId, grade.id, deleteData, function (success, result) {
                                    console.log(success, result)
                                    if (success) {
                                        popup.getDeliveries()
                                    } else {
                                        receipt_block.stop();
                                    }
                                })
                            } else {
                                receipt_block.stop();
                            }
                        }


                    }
                }
            });
        };

        $scope.gradeAverageCost = function (grade) {
            return {
                pos_title: $scope.model.controller.pos.title,
                inventory_value: grade.average_cost.average_cost,
                unit: $scope.model.controller.configuration.measurement_units.volume,
                date: moment(grade.average_cost.delivery_datetime).format('DD, MMMM Do YYYY, h:mm:ss a'),
            }
        }

        initControllerPage();
    }
})();
